import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from 'hooks/shared/error';
import { layerNodesKeys } from './queryKeys';
import type { LayerNodeDto, UpsertLayerNodeAssignmentInput } from './types';

export function useUpsertLayerNodeAssignmentMutation() {
  const queryClient = useQueryClient();

  return useMutation<LayerNodeDto, unknown, UpsertLayerNodeAssignmentInput>({
    mutationFn: async ({
      kind,
      id,
      groupGuid,
      targetFolderId,
    }: UpsertLayerNodeAssignmentInput) => {
      const resp = await axios.put<LayerNodeDto>(
        `${config.apiGateway.layer_nodes}/layer/${kind}/${id}/assignment`,
        {
          groupGuid,
          targetFolderId: targetFolderId ?? null,
        }
      );
      return resp.data;
    },
    onSuccess: () => {
      toast.success('Updated layer folder');
      queryClient.invalidateQueries({
        queryKey: layerNodesKeys.all(),
      });
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
  });
}
